import { initContract } from '@ts-rest/core';
import address from './address';
import catalog from './catalog';
import companies from './companies';
import contact from './contact';
import credit from './credit';
import exclusiveFilters from './exclusiveFilters';
import financemodels from './financemodels';
import images from './images';
import intercom from './intercom';
import invites from './invites';
import lifeCyclePolicy from './lifecycles';
import management from './management';
import notifications from './notifications';
import partners from './partners';
import region from './region';
import settings from './settings';
import additionalStock from './stock/additionalStock';
import reservedStock from './stock/reservedStock';
import stockLevels from './stock/stockLevels';
import bundleWeighting from './stock/weighting';
import terms from './terms';
import users from './users';

const c = initContract();
export default c.router({
  invites,
  companies,
  partners,
  images,
  catalog,
  terms,
  settings,
  credit,
  users,
  address,
  financemodels,
  stockLevels,
  additionalStock,
  reservedStock,
  bundleWeighting,
  notifications,
  exclusiveFilters,
  region,
  management,
  contact,
  lifeCyclePolicy,
  intercom
});
